var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 21,
    viewBox: "0 0 98 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.843 8.44599H91.116L85.808 3.13799C85.09 2.42099 85.09 1.25599 85.808 0.537994C86.526 -0.179006 87.69 -0.179006 88.408 0.537994L96.868 8.99799C97.214 9.34299 97.408 9.811 97.408 10.298C97.408 10.786 97.214 11.254 96.868 11.598L88.408 20.058C87.69 20.776 86.526 20.776 85.808 20.058C85.09 19.341 85.09 18.176 85.808 17.458L91.116 12.131H1.843C0.827 12.128 0.003 11.305 0 10.288C0.004 9.27199 0.827 8.44999 1.843 8.44599Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileArrow);
export default __webpack_public_path__ + "static/media/mobile-arrow.861f31e48d01cb26e03930bfecd73318.svg";
export { ForwardRef as ReactComponent };